<template>
	 <v-container>
		 <v-dialog title="修改学员进班日期" v-model="hideShow" width="500" persistent>
			<v-card>
				<v-card-title>
					<span>修改学员进班日期</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-text-field label="原日期" v-model="add.originDate" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.newJoinDate" label="新进班日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="add.newJoinDate" @input="menu1=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitUpdate" :loading="add.submitting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	export default {
		name:"update-student-price",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			classStudent:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.add.newJoinDate = "";
					this.add.originDate = this.classStudent.joinDate;
				}
			}
		},
		data(){
			return {
				menu1:false,
				add: {
					submitting:false,
					originDate:"",
					newJoinDate:""
				},
				hideShow:this.show
			}
		},
		mounted() {
			console.log("update student join date mounted");
		},
		methods:{
			submitUpdate(){
				console.log("提交修改");
				
				// 提交修改价格
				if (!this.add.newJoinDate) {
					that.$noty.error("请输入新的进班日期");
					return
				}
				this.add.submitting = true;
							
				// api
				const that = this;
				let url = `/edu/class/student/join/date/update`;
				let postData = {
					classStudentId:this.classStudent.id,
					newJoinDate:this.add.newJoinDate
				};
							
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.add.submitting = false;
							
							// 触发调用者success事件
							that.$emit("success",that.add.newJoinDate);
							
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
				
				
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>

